import { render, staticRenderFns } from "./WaitingForAccount.vue?vue&type=template&id=dab5f392&"
import script from "./WaitingForAccount.vue?vue&type=script&lang=js&"
export * from "./WaitingForAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports